import React, {Component, Fragment} from 'react';

import './cookieMsg.scss';

import closeIcon from 'assets/icons/close_icon.svg';

class CookieMsg extends Component{

    setCookie(cname, cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (365*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ';' + expires +";domain=" + window.location.hostname + ";path=/;";
        this.forceUpdate();
    }
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    render(){

        let cookie = this.getCookie("peeps_cookie");
        let show_msg = false;

        if (cookie !== 'true') {
            show_msg = true;
        }

        return(
            <div className={'cookieMsg ' + (show_msg ? '' : 'hide')}>
                {show_msg &&
                <Fragment>
                    <div className='content_wrapper'>
                        <span className='msg'>באתר זה משתמשים בקבצי עוגיות לשם שיפור חווית השימוש והשירותים שאנו מספקים לך ולצרכים שיווקים. המשך גלישתך מעידה על נכונותך לשימוש בקבצים אלו בהתאם למדיניות העוגיות שלנו </span>
                        <span className='cookieDivider'/>
                        <a href='/תנאי_שימוש_ופרטיות' className='privecyLink' target='_blank' rel='noreferrer noopener'>מדיניות פרטיות</a>
                    </div>
                    < img className='close_img' src={closeIcon} alt='/'
                          onClick={() => this.setCookie('peeps_cookie', true)}/>
                </Fragment>
                }
            </div>
        )
    }
}

export default CookieMsg;